const storedDeliveryDate = localStorage.getItem('lastSelectedDeliveryDate') || null;
const days = document.querySelectorAll('.day');
let currentIndex = 0;
const itemsPerPage = 2; // Number of days to show per page

function selectDeliveryDate() {
  let selected = false;

  // If there's a stored date, try to select the matching day
  if (storedDeliveryDate) {
    days.forEach((day, index) => {
      if (day.getAttribute('data-formated') === storedDeliveryDate) {
        day.classList.add('selected');
        selected = true;

        currentIndex = Math.floor(index / itemsPerPage) * itemsPerPage;
      } else {
        day.classList.remove('selected');
      }
    });
  }

  // If no match was found or no stored date, select the first day and set LS
  if (!selected && days.length > 0) {
    const firstDay = days[0];
    firstDay.classList.add('selected');
    const firstDate = firstDay.getAttribute('data-formated');
    localStorage.setItem('lastSelectedDeliveryDate', firstDate);
  }

  showDays();
}

// Function to control pagination and show the correct days
function showDays() {
  let visibleCount = 0; // Track visible days for button logic
  days.forEach((day, index) => {
    if (index >= currentIndex && index < currentIndex + itemsPerPage) {
      day.style.display = 'block';
      visibleCount++;
    } else {
      day.style.display = 'none';
    }
  });

  // Show/hide prev/next buttons based on currentIndex
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');

  if (currentIndex > 0) {
    prevBtn.classList.remove('disabled');
  } else {
    prevBtn.classList.add('disabled');
  }

  if (currentIndex + itemsPerPage < days.length && visibleCount > 0) {
    nextBtn.classList.remove('disabled');
  } else {
    nextBtn.classList.add('disabled');
  }

  // Ensure buttons are visible
  prevBtn.style.display = 'inline-block';
  nextBtn.style.display = 'inline-block';
}

// Event listeners for pagination buttons
document.getElementById('nextBtn').addEventListener('click', () => {
  currentIndex += itemsPerPage;
  showDays();
});

document.getElementById('prevBtn').addEventListener('click', () => {
  currentIndex -= itemsPerPage;
  showDays();
});

// Initial setup
selectDeliveryDate(); // Set the selected delivery date
showDays();           // Show the days based on pagination
